import { useParams, Navigate } from 'react-router';

export const Redirect = ({ to }) => {
    const params = useParams();

    let resolved = to;
    Object.entries(params).forEach(([key, value]) => {
        resolved = resolved.replace(`:${key}`, value);
    });

    return <Navigate to={resolved} replace />;
};

export const legacyRedirects = [
    {
        from: ['/', '/treatments/', '/activities/', '/projects/'],
        to: '/home',
    },
    {
        from: ['/projects/new'],
        to: '/f/projects/new',
    },
    {
        from: ['/projects/:featureId'],
        to: '/f/projects/:featureId',
    },
    {
        from: [
            '/treatments/:featureId',
            '/treatments/actuals/:featureId',
            '/f/treatments/actuals/:featureId',
        ],
        to: '/f/treatments/:featureId',
    },
    {
        from: ['/treatments/estimated/:featureId', '/f/treatments/estimated/:featureId'],
        to: '/f/estimated/:featureId',
    },
    {
        from: ['/pf/treatments/estimated/:featureId'],
        to: '/pf/estimated/:featureId',
    },
    {
        from: ['/pf/treatments/actuals/:featureId'],
        to: '/pf/treatments/:featureId',
    },
    {
        from: ['/treatments/new'],
        to: '/f/treatments/new',
    },
    {
        from: [
            '/activities/:featureId',
            '/activities/estimated/:featureId',
            '/f/activities/estimated/:featureId',
            '/activities/actuals/:featureId',
            '/f/activities/actuals/:featureId',
        ],
        to: '/f/activities/:featureId',
    },
    {
        from: ['/pf/activities/estimated/:featureId', '/pf/activities/actuals/:featureId'],
        to: '/pf/activities/:featureId',
    },
    {
        from: ['/activities/new'],
        to: '/f/activities/new',
    },
    {
        from: ['/admin'],
        to: '/admin/users',
    },
    {
        from: ['/workflow'],
        to: '/workflow/budget',
    },
];

export const routes = {
    newProject: ['/f/projects/new', '/pf/projects/new'], // TODO - EVAL: At this time (1/28/26) we don't have functionality at this route - consider removing in time.
    existingProject: ['/f/projects/:featureId', '/pf/projects/:featureId'],
    newTreatment: ['/f/treatments/new', '/pf/treatments/new'],
    existingTreatment: ['/f/treatments/:featureId', '/pf/treatments/:featureId'],
    newActivities: ['/f/activities/new', '/pf/activities/new'],
    existingActivities: ['/f/activities/:featureId', '/pf/activities/:featureId'],
};
